
























































import { PropType, defineComponent, ref } from '@vue/composition-api';

import { IWorkflowTransitionAction } from '@/models';
import auth from '@/mixins/auth';

import { useDeleteAction } from '@/composable/useWorkflowTransitionAction';

import DetailOptionsButton from '../common/DetailOptionsButton.vue';
import DeleteConfirmationDialog from '../common/DeleteConfirmationDialog.vue';

export default defineComponent({
  name: 'WorkflowTransitionActionDeleteOption',

  components: {
    DeleteConfirmationDialog,
    DetailOptionsButton
  },

  props: {
    workflowId: {
      type: Number,
      required: true
    },

    transitionId: {
      type: Number,
      required: true
    },

    disabled: {
      type: Boolean
    },

    action: {
      type: Object as PropType<IWorkflowTransitionAction>,
      required: true
    }
  },

  mixins: [auth],

  setup(props) {
    const deleteDialog = ref(false);

    function closeDeleteDialog() {
      deleteDialog.value = false;
    }

    const {
      deleteActionErrorReset,
      deleteAction,
      isDeletingAction,
      deleteActionError
    } = useDeleteAction(props.workflowId, props.transitionId);

    function removeAction() {
      clearErrors();
      deleteAction(props.action.id!, {
        onSuccess: () => {
          closeDeleteDialog();
        }
      });
    }

    function clearErrors() {
      deleteActionErrorReset();
    }

    return {
      deleteDialog,
      closeDeleteDialog,
      removeAction,
      deleteActionError,
      isDeletingAction,
      clearErrors
    };
  }
});
